import styled from "styled-components";

const H1 = styled.h1`
    font-size: ${props => (props.fs ? props.fs : "1.1rem")};
    font-weight: 400;
    color: #fff;
`;

export default H1;
